import { render, staticRenderFns } from "./QuizLoader.vue?vue&type=template&id=35bd8548&scoped=true"
import script from "./QuizLoader.vue?vue&type=script&lang=js"
export * from "./QuizLoader.vue?vue&type=script&lang=js"
import style0 from "./QuizLoader.vue?vue&type=style&index=0&id=35bd8548&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bd8548",
  null
  
)

export default component.exports